import { fetchAiPage } from "../services/contentApi";
import { ServicePageProvider, useServicePage, useServiceSection } from "./ServicePageContext";

export function AiPageProvider({ children }) {
  return (
    <ServicePageProvider fetchPage={fetchAiPage}>{children}</ServicePageProvider>
  );
}

export const useAiPage = useServicePage;
export const useAiSection = useServiceSection;
